export enum PopupIds {
    ACCOUNT_MANAGEMENT = 'account_management',
    CARDHOLDERS_CREDENTIALS = 'cardholders_credentials',
    DOWNLOAD_CLIENT_POPUP = 'download_client_popup',
    ECOMMPAY_ORDER_BOX_POPUP = 'ecommpay_order_box_popup',
    EULA_POLICY = 'eula_policy',
    FB_LIKE_PAGE = 'fb_like_page',
    LOGIN = 'login',
    NEW_PASS = 'new_pass',
    PAYMENT_POLICY = 'payment_policy',
    POLLING_WINDOW = 'polling_window_popup',
    PRIVACY_POLICY = 'privacy_policy',
    REFUND_POLICY = 'refund_policy',
    REGISTRATION = 'registration',
    RESTORE_PASS = 'restore_pass',
    OTP_LOGIN = 'otp_login',
    OTP_REQUEST_CODE = 'otp_request_code',
    SUPPORT_SUCCESS = 'support_success',
    SUPPORT_TICKET = 'support_ticket',
    TERMS_OF_SERVICE = 'terms_of_service',
    WEBGL_INFO_POPUP = 'webgl_info_popup',
    SUPPORT_WINDOW = 'support_window_popup',
    CANCEL_ACCOUNT_DELETION = 'cancel_account_deletion',
    IMPRESSUM = 'impressum',
}
